import ElementController from "../base-controllers/ElementController.js";
import { removeStaticAttr, setStaticAttr } from "../utils/morph/helpers.js";
/** Preview the same email header as Django, without uploading or sending mail. */
class OrganizationMailPreview extends ElementController {
    constructor() {
        super(...arguments);
        this.updatePreview = () => {
            const nameInput = this.root.querySelector('[name="system_email_name"]');
            const preview = this.root.querySelector("[data-mail-preview]");
            if (!nameInput || !preview)
                return;
            const customName = nameInput.value.trim();
            const name = customName || "Sajkla";
            const image = this.root.querySelector("[data-logo-image]");
            const logo = image && !image.hidden ? image.getAttribute("src") : null;
            const useDefault = !customName && !logo;
            preview.querySelector("[data-mail-preview-prefix]").textContent = name;
            preview.querySelector("[data-mail-identity-name]").textContent = name;
            for (const [selector, hidden] of [
                ["[data-mail-identity-default]", !useDefault],
                ["[data-mail-identity-custom]", useDefault],
                ["[data-mail-identity-logo-cell]", !logo],
            ]) {
                const element = preview.querySelector(selector);
                if (hidden)
                    setStaticAttr(element, "hidden", "");
                else
                    removeStaticAttr(element, "hidden");
            }
            const previewImage = preview.querySelector("[data-mail-identity-logo]");
            previewImage.alt = (this.root.dataset.logoAltTemplate ?? "").replace("%(name)s", () => name);
            if (logo)
                setStaticAttr(previewImage, "src", logo);
            else
                removeStaticAttr(previewImage, "src");
        };
    }
    init() {
        // Reuse the file widget's object URL and lifetime rather than owning a second upload.
        const image = this.root.querySelector("[data-logo-image]");
        if (image) {
            this.observer = new MutationObserver(this.updatePreview);
            this.observer.observe(image, { attributes: true, attributeFilter: ["src", "hidden"] });
        }
        this.updatePreview();
    }
    destroy() {
        this.observer?.disconnect();
    }
}
OrganizationMailPreview.id = "OrganizationMailPreview";
OrganizationMailPreview.binds = {
    '[name="system_email_name"]': [["input", "updatePreview"], ["change", "updatePreview"]],
};
export default OrganizationMailPreview;
//# sourceMappingURL=OrganizationMailPreview.js.map